export default __webpack_public_path__ + "static/media/intro_trading_ML_gcp.863c0afd.png";